<template>
  <div
    class="w-full"
  >
  <div
      v-if="showAddClusterModal"  
      class="fixed inset-0 z-300 flex items-start justify-center bg-black bg-opacity-50 p-4 overflow-y-auto" 
    >
      <div 
        class="bg-white rounded-lg shadow-2xl relative w-full"
      >
      </div>
    </div>
    
    <div
      class="!rounded-t-lg bg-[#009A78] text-white 
             text-xl 4xl:!text-[28px] 5xl:!text-[36px] 
             font-medium p-3 4xl:!p-6 5xl:!p-8 
             text-start relative"
    >
        {{ mode === "edit" ? "Edit Cluster" : "Add New Cluster" }}
    </div>
    
    <div class="p-6 md:p-10 4xl:p-14 5xl:p-20 flex flex-col gap-5 4xl:gap-7 5xl:gap-10">
      
      <form autocomplete="off" @submit.prevent class="grid grid-cols-1 md:grid-cols-2 gap-x-4 4xl:gap-x-6 5xl:gap-x-8 gap-y-5 4xl:gap-y-7 5xl:gap-y-10">
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="ConnectionType"
          >
            Connection Type
          </label>
          <div class="relative custom-select">
            <select
              id="ConnectionType"
              :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
              class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                     text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#009a78] font-normal !bg-none"
              v-model="connectionType"
              :disabled="mode === 'edit'"
            >
              <option
                v-for="option in connectionTypeOptions"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="ClusterName"
          >
            Cluster Name
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="ClusterName"
            type="text"
            v-model="ClusterName"
            autocomplete="new-text"
          />
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="Application"
          >
            Application
          </label>
          <div class="relative custom-select">
            <select
              id="Application"
              :class="{ '!bg-[#e9ecef]': mode === 'edit' }"
              class="form-select w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border-none appearance-none 
                     text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#009a78] font-normal !bg-none disabled:opacity-70 disabled:cursor-not-allowed"
              v-model="application"
              :disabled="mode === 'edit'"
            >
              <option
                v-for="option in applications"
                :key="option.value"
                :value="option.value"
              >
                {{ option.label }}
              </option>
            </select>
          </div>
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="PreviousWatt"
          >
            Previous Watt
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="PreviousWatt"
            type="text"
            v-model="previousWatt"
            autocomplete="new-text"
          />
        </div>
        
        <template v-if="connectionType !== 'Cellular'">
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal flex items-center" 
              for="LoRaWANNetworkKey"
            >
              LoRaWAN Network Key
              <button
                class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                       w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
                type="button"
                title="This ID is provided by the system provider. Please contact your provider if needed."
              >
                i
              </button>
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="LoRaWANNetworkKey"
              type="text"
              v-model="LoRaWANNetworkKey"
              autocomplete="new-text"
            />
          </div>
          
          <div class="col">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal flex items-center" 
              for="LoRaWANApplicationKey"
            >
              LoRaWAN Application Key
              <button
                class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                       w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
                type="button"
                title="This ID is provided by the system provider. Please contact your provider if needed."
              >
                i
              </button>
            </label>
            <input
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="LoRaWANApplicationKey"
              type="text"
              v-model="LoRaWANApplicationKey"
              autocomplete="new-text"
            />
          </div>
        </template>
        
        <div class="col" :class="{'md:col-span-2': connectionType === 'Cellular'}">
            <label 
              class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                     mb-2 4xl:mb-4 5xl:mb-5 font-normal flex items-center" 
              for="LoRaWANMulticastAddress"
              v-if="connectionType !== 'Cellular'"
            >
              LoRaWAN Multicast Address
              <button
                class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                       w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
                type="button"
                title="This ID is provided by the system provider. Please contact your provider if needed."
              >
                i
              </button>
            </label>
            <input
              v-if="connectionType !== 'Cellular'"
              class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                     px-3 4xl:px-5 5xl:px-6 
                     !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                     focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                     transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                     text-[#000000] font-normal placeholder:text-[#9B9A9A]"
              id="LoRaWANMulticastAddress"
              type="text"
              v-model="LoRaWANMulticastAddress"
              autocomplete="new-text"
            />
        </div>
        
        <div class="col" v-if="connectionType !== 'Cellular'">
          <label 
            class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="ElectricityTariffRate"
          >
            Electricity Tariff Rate (in Cent)
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="ElectricityTariffRate"
            type="number"
            v-model="ElectricityTariffRate"
            autocomplete="new-text"
          />
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="ClusterLatitude"
          >
            Cluster Latitude
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="ClusterLatitude"
            type="text"
            v-model="ClusterLatitude"
            autocomplete="new-text"
          />
        </div>
        
        <div class="col">
          <label 
            class="block text-[#009A78] text-base 4xl:!text-[22px] 5xl:!text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal" 
            for="ClusterLongitude"
          >
            Cluster Longitude
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="ClusterLongitude"
            type="text"
            v-model="ClusterLongitude"
            autocomplete="new-text"
          />
        </div>
        
        <div class="col col-span-1 md:col-span-2">
          <label 
            class="block text-[#009A78] text-base 4xl:text-[22px] 5xl:text-[30px] 
                   mb-2 4xl:mb-4 5xl:mb-5 font-normal flex items-center" 
            for="LuxActivationValue"
          >
            Lux Activation Value
            <button
              class="bg-[#009a78] text-white text-center !text-[10px] 4xl:!text-base 5xl:!text-xl 
                     w-4 h-4 4xl:w-6 4xl:h-6 5xl:!w-7 5xl:!h-7 !rounded-full ml-1"
              type="button"
              title="Optional"
            >
              i
            </button>
          </label>
          <input
            class="form-control w-full h-[51px] 4xl:h-[65px] 5xl:h-[80px] 
                   px-3 4xl:px-5 5xl:px-6 
                   !rounded-lg !bg-[#F0F0F0] border border-gray-300 
                   focus:border-[#009A78] focus:ring-2 focus:ring-[#3b82f6] focus:!bg-white 
                   transition duration-150 text-[16px] 4xl:!text-[22px] 5xl:!text-[30px] 
                   text-[#000000] font-normal placeholder:text-[#9B9A9A]"
            id="LuxActivationValue"
            type="number"
            min="0"
            v-model="LuxActivationValue"
            autocomplete="new-text"
          />
        </div>
        
        <div class="col hidden md:block"></div> 
        
      </form>
    </div>
    
    <div
      class="p-6 md:p-10 4xl:p-14 5xl:p-20 
             flex flex-col gap-5 4xl:gap-7 5xl:gap-9 
             border-t border-gray-200 !rounded-b-lg"
    >
      <button
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#009A78] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#00795e] transition duration-200"
        type="button"
        @click="handleSave"
      >
        Save
      </button>
      
      <button
        v-show="mode === 'edit'"
        class="w-full h-[51px] 4xl:!h-[72px] 5xl:!h-[104px] 
               !rounded-lg 5xl:!rounded-2xl bg-[#FF9700] text-white 
               text-base 4xl:!text-[22px] 5xl:!text-[30px] 
               font-normal hover:bg-[#cc7a00] transition duration-200"
        type="button"
        @click="handleDelete"
      >
        Delete
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ["isEdit", "formEdit"],
  watch: {
    isEdit: {
      handler: function (val) {
        this.mode = val ? "edit" : "add";
        this.ClusterID = val ? this.formEdit.ClusterID : "";
        this.connectionType = val ? this.formEdit.ConnectionTypeID : "";
        this.ClusterName = val ? this.formEdit.ClusterName : "";
        this.application = val ? this.formEdit.ApplicationID : "";
        this.previousWatt = val ? this.formEdit.PreviousWatt : "";
        this.LoRaWANNetworkKey = val ? this.formEdit.LoRaWANNetworkKey : "";
        this.LoRaWANApplicationKey = val
          ? this.formEdit.LoRaWANApplicationKey
          : "";
        this.LoRaWANMulticastAddress = val
          ? this.formEdit.LoRaWANMulticastAddress
          : "";
        this.ElectricityTariffRate = val
          ? this.formEdit.ElectricityTariffRate
          : "";
        this.ClusterLatitude = val ? this.formEdit.ClusterLatitude : "";
        this.ClusterLongitude = val ? this.formEdit.ClusterLongitude : "";
        this.LuxActivationValue = val ? this.formEdit.LuxActivationValue : "";
      },
      deep: true,
      immediate: true,
    },
    formEdit(val) {
      this.mode = this.isEdit ? "edit" : "add";
      this.connectionType = val.ConnectionTypeID;
      this.ClusterID = val.ClusterID;
      this.ClusterName = val.ClusterName;
      this.application = val.ApplicationID;
      this.previousWatt = val.PreviousWatt;
      this.LoRaWANNetworkKey = val.LoRaWANNetworkKey;
      this.LoRaWANApplicationKey = val.LoRaWANApplicationKey;
      this.LoRaWANMulticastAddress = val.LoRaWANMulticastAddress;
      this.ElectricityTariffRate = val.ElectricityTariffRate;
      this.ClusterLatitude = val.ClusterLatitude;
      this.ClusterLongitude = val.ClusterLongitude;
      this.LuxActivationValue = val.LuxActivationValue;
    },
  },
  data() {
    return {
      ClusterID: "",
      mode: "add",
      connectionType: "",
      ClusterName: "",
      application: "",
      applications: [],
      previousWatt: "",
      LoRaWANNetworkKey: "",
      LoRaWANApplicationKey: "",
      LoRaWANMulticastAddress: "",
      ElectricityTariffRate: "",
      LuxActivationValue: 0,
      ClusterLatitude: "",
      ClusterLongitude: "",
      connectionTypeOptions: [],
    };
  },
  emits: ["closeModal", "onDelete", "onSave"],
  methods: {
    getApplication() {
      this.applications = [];
      // Logic for Application (assuming it works or will be similarly corrected)
      this.$http.get(":11005/api/v1/application").then((res) => {
        if (!res.error) {
          let response = res.message;
          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].AppName,
              value: response[i].AppId,
            };
            this.applications.push(obj);
          }
        }
      });
    },
    getConnectionType() {
      this.connectionTypeOptions = [];
      
      this.$http.get(":11005/api/v1/conntype").then((res) => {
        if (!res.error) {
          let response = res.message;
          for (var i = 0; i < response.length; i++) {
            let obj = {
              // *** FIX HERE: Using lowercase 'conntypename' and 'conntypeid' ***
              label: response[i].conntypename, 
              value: response[i].conntypeid,   
            };
            this.connectionTypeOptions.push(obj);
          }
        }
      })
      .catch(err => {
        console.error("Error fetching or parsing connection types:", err);
      });
    },
    handleSave() {
      // Logic preserved
      this.$emit("onSave", this.getFormData(), this.ClusterID);
      this.resetForm();
    },
    handleDelete() {
      // Logic preserved
      this.$emit("onDelete", this.ClusterID);
      this.resetForm();
    },
    getFormData() {
      // Logic preserved
      return {
        ConnTypeID: this.connectionType,
        ClusterName: this.ClusterName,
        AppID: this.application,
        PreviousWatt: parseInt(this.previousWatt),
        McNwkSKey: this.LoRaWANNetworkKey,
        McAppSKey: this.LoRaWANApplicationKey,
        McAddr: this.LoRaWANMulticastAddress,
        TariffRate: parseFloat(this.ElectricityTariffRate),
        Latitude: parseFloat(this.ClusterLatitude),
        Longitude: parseFloat(this.ClusterLongitude),
        LuxActivationValue: parseInt(this.LuxActivationValue),
      };
    },
    resetForm() {
      this.connectionType = "";
      this.ClusterID = "";
      this.ClusterName = "";
      this.application = "";
      this.previousWatt = "";
      this.LoRaWANNetworkKey = "";
      this.LoRaWANApplicationKey = "";
      this.LoRaWANMulticastAddress = "";
      this.ElectricityTariffRate = "";
      this.LuxActivationValue = 0;
      this.ClusterLatitude = "";
      this.ClusterLongitude = "";
    },
  },
  mounted() {
    console.log("Modal Mounted, attempting API calls...");
    this.getConnectionType();
    this.getApplication();
  },
};
</script>

<style lang="scss" scoped>
// Inherit/replicate the styles from the holidays modal for consistency
.custom-select::after {
  content: "▼";
  position: absolute;
  right: 0.75rem;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #009a78; 
  font-size: 16px; /* Default size */
}

// Global datepicker styling to match the holidays modal input field look
.datepicker-custom {
  .dp__input_wrap {
    height: 100%;
  }
  .dp__input {
    height: 100%;
    border: none;
    border-radius: 8px;
    background: #f0f0f0;
    color: #000000 !important;
    font-weight: 400 !important;
    font-size: 16px;
    padding: 0.75rem 1rem; /* Adjusted for better alignment */
    font-family: inherit;
    &::placeholder {
      color: #9b9a9a !important;
      font-weight: 400 !important;
    }
  }
  .dp__input:focus {
    box-shadow: 0 0 0 1px #3b82f6 !important;
    border-color: #3b82f6 !important;
    outline: none;
  }
}

// Responsive Styles (Replicated from Holidays Modal CSS)
@media (min-width: 2560px) {
  .custom-select::after {
    font-size: 22px; 
    right: 1.5rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 22px !important;
      padding: 1.2rem 1.5rem !important; 
    }
  }
}

@media (min-width: 3840px) {
  .custom-select::after {
    font-size: 30px; 
    right: 2rem;
  }
  .datepicker-custom {
    .dp__input {
      font-size: 30px !important;
      padding: 1.8rem 2rem !important; 
    }
  }
}
</style>